import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const StadiumPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Drone Stadium & Dome Cleaning - Flyby Shine</title>
                        <meta name="description" content="Drone cleaning services for stadiums and domes. Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project." />
                        <meta name="keywords" content="Stadium Cleaning, Stadium cleaning services, commercial stadium cleaning, industrial stadium cleaning, hygienic stadium cleaning, expert stadium cleaning services, safe stadium cleaning, thorough stadium cleaning, professional stadium cleaning, reliable stadium cleaning, top-quality stadium cleaning, stadium cleaning services, stadium cleaning solutions, stadium cleaning experts" />
                        <meta property="og:image" content="/assets/stadium2.jpg" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Commercial & Industrial'}
                    title={'Stadium & Dome Cleaning'}
                    description={`Acceptional drone cleaning services for stadiums and domes.`}
                    banner={{ image: '/assets/stadium2.jpg', alt: 'A cleaned stadium' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for stadiums and domes.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{
                            image: '/assets/stadium3.jpg', alt: 'stadium displayed'
                        }}
                        title={'Safe and Non-Disruptive'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'Using drones reduces the need for ladders, lifts, and scaffolding, lowering accident risks. Our process is faster and less intrusive than traditional methods, keeping your stadium clean without disrupting events.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. '}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',
                            thumbnail: '/assets/videos/thumbnails/windowclean.png',

                        }}
                        title={'Advanced Drone Technology'}
                        heading={{ image: '/assets/water.svg', alt: 'water icon' }}
                        description={'Our advanced drone technology allows us to reach high areas safely and efficiently, providing a thorough cleaning solution for stadiums and domes.'}
                    />


                </ZigZag>
                <Contact />
            </PageShell>


        </>
    )
}

export default StadiumPage
